import React, { useEffect, useState,useRef } from "react";
import { useDownloadExcel } from "react-export-table-to-excel";
import leftArrow from "../../assets/Images/left-arrow.png";
import rightArrow from "../../assets/Images/right-arrow.png";
import ProjectHandoverForm from "./project-handover-form";
import plusIcon from "../../assets/Icons/plus_icon.png";
import { COMMON_API } from "../../services/apiCalls/commonApi";
import { toast } from "react-toastify";
import Filter from "../../assets/Icons/filter.png";
import ExcelExport from "../../compnenets/commons/xls";
import PdfIcon from "../../assets/Icons/Pdf_Icon.png";
import DownloadIcon from "../../assets/Icons/Download_Icon.png";
import Download from "../../assets/Icons/download.png";
import Modal from "react-responsive-modal";
import Close from "../../assets/Images/close.png"
function ProjectHandoverList() {
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(true);
  const tableRef = useRef(null);
  const [StartDate, setStartDate] = useState("");
  const [EndDate, setEndDate] = useState("");
  const [description, setDescription] = useState("");
  const [projectHandovers, setProjectHandovers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const rowsPerPage = 10;
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "machinery resources",
    sheet: "Machinry",
  });
  const getProjectHandovers = async () => {
    const user = localStorage.getItem("state");
    const state = JSON.parse(user);
    
    const payload={
        UserID: state.user.user_id,
        SearchDescription:description,
        StartDate:StartDate,
        EndDate:EndDate
    }
    try {
      const response = await COMMON_API.getProjectHandover(payload);
      if (response.status === 200) {
        setProjectHandovers(response.projecthandover);
      } else {
        console.error("Failed to get Project Handovers:", response.message);
      }
    } catch (error) {
      console.error("Error getting Project Handovers:", error);
    }
  };

  useEffect(() => {
    getProjectHandovers();
  }, []);

  const totalPages = Math.ceil(projectHandovers.length / rowsPerPage);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = projectHandovers?.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const downloadFile = (fileUrl) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = decodeURIComponent(fileUrl?.split("/").pop()); // Suggest the filename from the URL
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Clean up the DOM
  };

  return (
    <>
      <div className="select-tab" ></div>
      <div className="d-flex justify-content-end mb-2">
          <div className="download-icon">
            <img src={Download} onClick={onDownload} width={15} height={15} />
          </div>
          <div className="filter-icon mx-2 my-auto">
            <img
              className=""
              onClick={() => {
                setOpen(true);
                // getMachinery();
              }}
              src={Filter}
              width={20}
            />
          </div>
          <div className="my-auto">
          <span style={{ cursor: "pointer", fontSize: 12, fontWeight: 500, background: "#8add79f7", padding: 5, borderRadius: 12 }}   onClick={(e) => {
            
              getProjectHandovers();
            
            }}>Clear filters</span>
        </div>
        </div>
      <div
        className="table-container"
        style={{
          margin: "15px 0px 50px 0px",
        }}
      >
        <table className="custom-table">
          <thead className="table-header">
            <tr>
              <th> Sr No</th>
              <th>Project Name</th>
              <th>Description</th>
              <th>Attachment</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((projectHandovers, index) => (
              <tr
                key={projectHandovers.ID}
              
              >
                <td>{index + 1 + (currentPage - 1) * 10}</td>
                <td>{projectHandovers.ProjectName}</td>
                <td>{projectHandovers.Description}</td>
                <td>
  {projectHandovers.Attachment ? (
    <>
      <img
        src={PdfIcon}
        alt="PDF Icon"
        style={{ width: "16px", marginRight: "8px" }}
      />
      {decodeURIComponent(
        projectHandovers.Attachment?.split("/").pop()
      )}
      <img
    src={DownloadIcon}
    alt="Download Icon"
    style={{
      width: "16px",
      marginLeft: "8px",
      cursor: "pointer",
    }}
    onClick={(e) => {
      e.stopPropagation();
      if (projectHandovers.Attachment) {
        downloadFile(projectHandovers.Attachment);
      }
    }}
  />
    </>
  ) : null}

  
</td>

              </tr>
            ))}
          </tbody>
        </table>
        <div
          className="pagination"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px 15px",
          }}
        >
          <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
            Showing{" "}
            {Math.min(
              (currentPage - 1) * rowsPerPage + 1,
              projectHandovers.length
            )}
            to{" "}
            {Math.min(currentPage * rowsPerPage, projectHandovers.length)}{" "}
            of {projectHandovers.length} entries
          </div>

          <div
            className="pagination-buttons"
            style={{
              fontSize: "14px",
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              gap: "5px",
            }}
          >
            <button
              onClick={() => handleClick(Math.max(1, currentPage - 1))}
              disabled={currentPage === 1}
              style={{
                background: "none",
                border: "none",
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
              }}
            >
              <img
                src={leftArrow}
                alt="Previous"
                height="10px"
                width="10px"
                style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
              />
            </button>

            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i}
                onClick={() => handleClick(i + 1)}
                style={{
                  background:
                    currentPage === i + 1 ? "#00B69B" : "transparent",
                  color: currentPage === i + 1 ? "#fff" : "#000",
                  border: "none",
                  borderRadius: "50%",
                  width: "30px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                {i + 1}
              </button>
            ))}

            <button
              onClick={() =>
                handleClick(Math.min(totalPages, currentPage + 1))
              }
              disabled={currentPage === totalPages}
              style={{
                background: "none",
                border: "none",
                cursor:
                  currentPage === totalPages ? "not-allowed" : "pointer",
              }}
            >
              <img
                src={rightArrow}
                alt="Next"
                height="10px"
                width="10px"
                style={{
                  opacity: currentPage === totalPages ? 0.5 : 1,
                }}
              />
            </button>
          </div>
        </div>
      </div>

      <Modal open={open} onClose={onCloseModal} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">Document Repository Filter</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setOpen(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="card mt-0 card-bd-none">
            <div className="card-body">
              <div className="row">
                <div className="col-6">
                  <label className="filter-label">Start date</label>
                  <input
                    type="date"
                    value={StartDate}
                    onChange={(e) => {
                     
                      setStartDate(e.target.value);
                    }}
                    name="StartDate"
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">End date</label>
                  <input
                    type="date"
                    value={EndDate}
                    onChange={(e) => {
                     
                      setEndDate(e.target.value);
                    }}
                    name="EndDate"
                    className="form-control shadow-none"
                  />
                </div>
              </div>
              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Description</label>
                  <input
                    type="text"
                    value={description}
                    onChange={(e) => {
                     
                      setDescription(e.target.value);
                    }}
                    name="description"
                    className="form-control shadow-none"
                  />
                </div>
              
              </div>
            
            </div>
          </div>
        </div>
        
     
        <div className="d-flex justify-content-center mt-4 pb-4">
          <button
            onClick={(e) => {
              getProjectHandovers();
              setOpen(false)
              setStartDate('')
            setEndDate('')
            setDescription('')
            }}
            className="btn btn-primary"
          >
            Filter
          </button>
        </div>
      </Modal>
    </>
  );
}

export default ProjectHandoverList;
